import type { HTMLAttributes, ReactNode } from "react";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "raised" | "flat";
  children: ReactNode;
}

export function Card({
  variant = "default",
  className,
  children,
  ...rest
}: CardProps): React.ReactElement {
  const classes = [
    "card",
    variant === "raised" ? "card--raised" : null,
    variant === "flat" ? "card--flat" : null,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
